import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface NonAmendableWording {
  nonAmendableDetail: string
  nonAmendableLabel: string
  showNonAmendableWording: boolean
}

function useNonAmendableWording(isEligible: boolean): NonAmendableWording {
  const intl = useIntl()

  return useMemo(() => {
    return {
      showNonAmendableWording: isEligible,
      nonAmendableDetail: intl.formatMessage({
        id: 'VyHD32GOF9SGwwoBdAjq',
        defaultMessage: 'Please note that ’Non-Refundable and Non-Amendable’ packages are guaranteed at the time of booking and not eligible for a refund or date change. Accordingly, please select your package carefully and take note of any cancellation policy applicable to your purchase.',
        description: 'Treatment modal body explaining the non-refundable and non-amendable package policy',
      }),
      nonAmendableLabel: intl.formatMessage({
        id: 'iEahFEcRVkTQgjxdC2Q8',
        defaultMessage: 'Non-Refundable and Non-Amendable',
        description: 'Treatment label for eligible accommodation rates that cannot be refunded or amended',
      }),
    }
  }, [intl, isEligible])
}

export default useNonAmendableWording
